import React from 'react';
import FireProvider from './contexts/fireContext';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import Navigation from './navigation';
import { PersistGate } from 'redux-persist/integration/react';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <FireProvider>
          <Navigation />
        </FireProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
